import { Money } from '@ap/interface-bspc-core';
import { ApplicantPrivateLease, PrivateLease } from '@ap/ap-interface-apix-hypotheken-berekening';

export class PrivateLeaseBuilder {
    private mainApplicant: ApplicantPrivateLease;
    private coApplicant: ApplicantPrivateLease;

    withMainApplicant(mainApplicant: ApplicantPrivateLease): this {
        this.mainApplicant = mainApplicant;
        return this;
    }

    withCoApplicant(coApplicant: ApplicantPrivateLease): this {
        this.coApplicant = coApplicant;
        return this;
    }

    build(): PrivateLease {
        return {
            main_applicant: this.mainApplicant,
            co_applicant: this.coApplicant
        } as PrivateLease;
    }
}
export class ApplicantPrivateLeaseBuilder {
    private monthlyAmount: Money;
    private durationInMonths: number;

    withDurationInMonths(durationInMonths: number): this {
        this.durationInMonths = durationInMonths;
        return this;
    }

    withMonthlyAmount(monthlyAmount: Money): this {
        this.monthlyAmount = monthlyAmount;
        return this;
    }

    build(): ApplicantPrivateLease {
        return {
            monthly_amount: this.monthlyAmount,
            duration_in_months: this.durationInMonths
        } as ApplicantPrivateLease;
    }
}
